import React, { useEffect, useState } from "react";
import "../styles/Board2.css";

/**
 * FlipChar - renders a single character with top/bottom faces and flips
 * when `char` prop changes. Controlled flip only when the char changes.
 *
 * Props:
 *  - char: string (single character, may be space)
 *  - flipKey: string/number used to re-trigger full flip if needed (optional)
 */
const FlipChar = ({ char = " " }) => {
  const [prev, setPrev] = useState(char);
  const [flipping, setFlipping] = useState(false);
  const displayChar = (char === null || char === undefined) ? " " : String(char);

  useEffect(() => {
    if (displayChar !== prev) {
      // trigger flip
      setFlipping(true);
      const t = setTimeout(() => {
        setFlipping(false);
        setPrev(displayChar);
      }, 500); // animation duration sync with CSS
      return () => clearTimeout(t);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayChar]);

  // When not flipping, top shows current char
  // When flipping, CSS handles the rotation and shows prev -> new transition
  return (
    <span className={`flip-char ${flipping ? "flipping" : ""}`} aria-hidden>
      <span className="fc-top">
        <span className="fc-char">{flipping ? prev : displayChar}</span>
      </span>
      <span className="fc-bottom">
        <span className="fc-char">{displayChar}</span>
      </span>

      {/* hidden accessible text */}
      <span className="sr-only">{displayChar}</span>
    </span>
  );
};

export default FlipChar;
